// App icons - JSX components with CSS-controlled sizing
// Icons use viewBox (no width/height) and currentColor for flexible reuse

export const PlusIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="11" width="16" height="2" fill="currentColor" />
    <rect x="11" y="4" width="2" height="16" fill="currentColor" />
  </svg>
);

export const CheckIcon = ({ fill = '#1E90FF' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <rect x="4" y="14" width="2" height="2" transform="rotate(-90 4 14)" fill={fill}/>
      <rect x="8" y="18" width="2" height="2" transform="rotate(-90 8 18)" fill={fill}/>
      <rect x="12" y="14" width="2" height="2" transform="rotate(-90 12 14)" fill={fill}/>
      <rect x="16" y="10" width="2" height="2" transform="rotate(-90 16 10)" fill={fill}/>
      <rect x="6" y="16" width="2" height="2" transform="rotate(-90 6 16)" fill={fill}/>
      <rect x="10" y="16" width="2" height="2" transform="rotate(-90 10 16)" fill={fill}/>
      <rect x="14" y="12" width="2" height="2" transform="rotate(-90 14 12)" fill={fill}/>
      <rect x="18" y="8" width="2" height="2" transform="rotate(-90 18 8)" fill={fill}/>
    </svg>
  );
};

export const CreateIcon = () => (
  <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="6.41669" y="1.75" width="1.16667" height="1.16667" fill="currentColor"/>
    <rect x="7.58331" y="12.25" width="1.16667" height="1.16667" transform="rotate(-180 7.58331 12.25)" fill="currentColor"/>
    <rect x="5.25" y="4.08333" width="1.16667" height="1.16667" fill="currentColor"/>
    <rect x="5.25" y="2.91667" width="1.16667" height="1.16667" fill="currentColor"/>
    <rect x="8.75" y="9.91667" width="1.16667" height="1.16667" transform="rotate(-180 8.75 9.91667)" fill="currentColor"/>
    <rect x="8.75" y="11.0833" width="1.16667" height="1.16667" transform="rotate(-180 8.75 11.0833)" fill="currentColor"/>
    <rect x="4.08331" y="5.25" width="1.16667" height="1.16667" fill="currentColor"/>
    <rect x="2.91669" y="5.25" width="1.16667" height="1.16667" fill="currentColor"/>
    <rect x="9.91669" y="8.75" width="1.16667" height="1.16667" transform="rotate(-180 9.91669 8.75)" fill="currentColor"/>
    <rect x="11.0833" y="8.75" width="1.16667" height="1.16667" transform="rotate(-180 11.0833 8.75)" fill="currentColor"/>
    <rect x="1.75" y="6.41667" width="1.16667" height="1.16667" fill="currentColor"/>
    <rect x="7.58331" y="4.08333" width="1.16667" height="1.16667" fill="currentColor"/>
    <rect x="7.58331" y="2.91667" width="1.16667" height="1.16667" fill="currentColor"/>
    <rect x="6.41669" y="9.91667" width="1.16667" height="1.16667" transform="rotate(-180 6.41669 9.91667)" fill="currentColor"/>
    <rect x="6.41669" y="11.0833" width="1.16667" height="1.16667" transform="rotate(-180 6.41669 11.0833)" fill="currentColor"/>
    <rect x="8.75" y="5.25" width="1.16667" height="1.16667" fill="currentColor"/>
    <rect x="9.91669" y="5.25" width="1.16667" height="1.16667" fill="currentColor"/>
    <rect x="5.25" y="8.75" width="1.16667" height="1.16667" transform="rotate(-180 5.25 8.75)" fill="currentColor"/>
    <rect x="4.08331" y="8.75" width="1.16667" height="1.16667" transform="rotate(-180 4.08331 8.75)" fill="currentColor"/>
    <rect x="11.0833" y="6.41667" width="1.16667" height="1.16667" fill="currentColor"/>
  </svg>
);

export const CrownIcon = () => (
  <svg viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.96487 8.89478H1.97656V9.88309H2.96487V8.89478Z" fill="#FFA500"/>
      <path d="M3.95413 8.89478H2.96582V9.88309H3.95413V8.89478Z" fill="#FFA500"/>
      <path d="M4.94241 8.89478H3.9541V9.88309H4.94241V8.89478Z" fill="#FFA500"/>
      <path d="M5.93088 8.89482H4.94257V9.88313H5.93088V8.89482Z" fill="#FFA500"/>
      <path d="M6.91904 8.89482H5.93073V9.88313H6.91904V8.89482Z" fill="#FFA500"/>
      <path d="M7.90628 8.89482H6.91797V9.88313H7.90628V8.89482Z" fill="#FFA500"/>
      <path d="M2.96487 7.90625H1.97656V8.89456H2.96487V7.90625Z" fill="#FFA500"/>
      <path d="M11.8604 8.89478H10.8721V9.88309H11.8604V8.89478Z" fill="#FFA500"/>
      <path d="M10.8721 8.89478H9.88379V9.88309H10.8721V8.89478Z" fill="#FFA500"/>
      <path d="M9.8826 8.89482H8.89429V9.88313H9.8826V8.89482Z" fill="#FFA500"/>
      <path d="M8.89536 8.89482H7.90704V9.88313H8.89536V8.89482Z" fill="#FFA500"/>
      <path d="M11.8604 7.90625H10.8721V8.89456H11.8604V7.90625Z" fill="#FFA500"/>
      <path d="M2.96487 6.91821H1.97656V7.90652H2.96487V6.91821Z" fill="#FFA500"/>
      <path d="M11.8604 6.91821H10.8721V7.90652H11.8604V6.91821Z" fill="#FFA500"/>
      <path d="M5.93088 5.9299H4.94257V6.91821H5.93088V5.9299Z" fill="#FFA500"/>
      <path d="M8.89536 5.9299H7.90704V6.91821H8.89536V5.9299Z" fill="#FFA500"/>
      <path d="M5.93088 4.94174H4.94257V5.93005H5.93088V4.94174Z" fill="#FFA500"/>
      <path d="M8.89536 4.94174H7.90704V5.93005H8.89536V4.94174Z" fill="#FFA500"/>
      <path d="M2.96487 5.92993H1.97656V6.91824H2.96487V5.92993Z" fill="#FFA500"/>
      <path d="M11.8604 5.92993H10.8721V6.91824H11.8604V5.92993Z" fill="#FFA500"/>
      <path d="M3.95401 7.90619H2.9657V8.8945H3.95401V7.90619Z" fill="#FFFF00"/>
      <path d="M4.94229 7.90619H3.95398V8.8945H4.94229V7.90619Z" fill="#FFFF00"/>
      <path d="M5.93076 7.90614H4.94244V8.89445H5.93076V7.90614Z" fill="#FFFF00"/>
      <path d="M6.91891 7.90614H5.9306V8.89445H6.91891V7.90614Z" fill="#FFFF00"/>
      <path d="M7.90616 7.90614H6.91785V8.89445H7.90616V7.90614Z" fill="#FFFF00"/>
      <path d="M10.872 7.90619H9.88367V8.8945H10.872V7.90619Z" fill="#FFFF00"/>
      <path d="M9.88248 7.90614H8.89417V8.89445H9.88248V7.90614Z" fill="#FFFF00"/>
      <path d="M8.89523 7.90614H7.90692V8.89445H8.89523V7.90614Z" fill="#FFFF00"/>
      <path d="M3.95401 6.91815H2.9657V7.90646H3.95401V6.91815Z" fill="#FFFF00"/>
      <path d="M4.94229 6.91815H3.95398V7.90646H4.94229V6.91815Z" fill="#FFFF00"/>
      <path d="M5.93076 6.91821H4.94244V7.90652H5.93076V6.91821Z" fill="#FFFF00"/>
      <path d="M6.91891 6.91821H5.9306V7.90652H6.91891V6.91821Z" fill="#FFFF00"/>
      <path d="M7.90616 6.91821H6.91785V7.90652H7.90616V6.91821Z" fill="#FFFF00"/>
      <path d="M10.872 6.91815H9.88367V7.90646H10.872V6.91815Z" fill="#FFFF00"/>
      <path d="M9.88248 6.91821H8.89417V7.90652H9.88248V6.91821Z" fill="#FFFF00"/>
      <path d="M8.89523 6.91821H7.90692V7.90652H8.89523V6.91821Z" fill="#FFFF00"/>
      <path d="M3.95401 5.92987H2.9657V6.91818H3.95401V5.92987Z" fill="#FFFF00"/>
      <path d="M6.91891 5.92984H5.9306V6.91815H6.91891V5.92984Z" fill="#FFFF00"/>
      <path d="M7.90616 5.92984H6.91785V6.91815H7.90616V5.92984Z" fill="#FFFF00"/>
      <path d="M10.872 5.92987H9.88367V6.91818H10.872V5.92987Z" fill="#FFFF00"/>
      <path d="M11.8603 4.94159H10.8719V5.9299H11.8603V4.94159Z" fill="#FFFF00"/>
      <path d="M12.8488 4.94168H11.8605V5.92999H12.8488V4.94168Z" fill="#FFFF00"/>
      <path d="M2.96475 4.94159H1.97644V5.9299H2.96475V4.94159Z" fill="#FFFF00"/>
      <path d="M3.95401 4.94159H2.9657V5.9299H3.95401V4.94159Z" fill="#FFFF00"/>
      <path d="M6.91891 4.94168H5.9306V5.92999H6.91891V4.94168Z" fill="#FFFF00"/>
      <path d="M7.90616 4.94168H6.91785V5.92999H7.90616V4.94168Z" fill="#FFFF00"/>
      <path d="M6.91891 1.97678H5.9306V2.96509H6.91891V1.97678Z" fill="#FFFF00"/>
      <path d="M7.90616 1.97678H6.91785V2.96509H7.90616V1.97678Z" fill="#FFFF00"/>
      <path d="M10.872 4.94159H9.88367V5.9299H10.872V4.94159Z" fill="#FFFF00"/>
      <path d="M7.90616 0.988159H6.91785V1.97647H7.90616V0.988159Z" fill="#FFFF00"/>
      <path d="M1.97635 4.94168H0.988037V5.92999H1.97635V4.94168Z" fill="#FFFF00"/>
      <path d="M6.91891 3.95331H5.9306V4.94162H6.91891V3.95331Z" fill="#FFFF00"/>
      <path d="M7.90616 3.95331H6.91785V4.94162H7.90616V3.95331Z" fill="#FFFF00"/>
      <path d="M12.8488 3.95331H11.8605V4.94162H12.8488V3.95331Z" fill="#FFFF00"/>
      <path d="M2.96475 3.95331H1.97644V4.94162H2.96475V3.95331Z" fill="#FFFF00"/>
      <path d="M5.93088 3.95337H4.94257V4.94168H5.93088V3.95337Z" fill="black"/>
      <path d="M8.89536 3.95337H7.90704V4.94168H8.89536V3.95337Z" fill="black"/>
      <path d="M7.90628 2.96498H6.91797V3.95329H7.90628V2.96498Z" fill="black"/>
      <path d="M6.91904 2.96498H5.93073V3.95329H6.91904V2.96498Z" fill="black"/>
      <path d="M8.89536 9.88297H7.90704V10.8713H8.89536V9.88297Z" fill="black"/>
      <path d="M9.8826 9.88297H8.89429V10.8713H9.8826V9.88297Z" fill="black"/>
      <path d="M10.8721 9.88306H9.88379V10.8714H10.8721V9.88306Z" fill="black"/>
      <path d="M11.8604 9.88306H10.8721V10.8714H11.8604V9.88306Z" fill="black"/>
      <path d="M12.8489 9.88297H11.8606V10.8713H12.8489V9.88297Z" fill="black"/>
      <path d="M1.97647 9.88297H0.988159V10.8713H1.97647V9.88297Z" fill="black"/>
      <path d="M2.96487 9.88306H1.97656V10.8714H2.96487V9.88306Z" fill="black"/>
      <path d="M3.95413 9.88306H2.96582V10.8714H3.95413V9.88306Z" fill="black"/>
      <path d="M4.94241 9.88306H3.9541V10.8714H4.94241V9.88306Z" fill="black"/>
      <path d="M5.93088 9.88297H4.94257V10.8713H5.93088V9.88297Z" fill="black"/>
      <path d="M6.91904 9.88297H5.93073V10.8713H6.91904V9.88297Z" fill="black"/>
      <path d="M7.90628 9.88297H6.91797V10.8713H7.90628V9.88297Z" fill="black"/>
      <path d="M1.97647 8.89482H0.988159V9.88313H1.97647V8.89482Z" fill="black"/>
      <path d="M1.97647 7.9062H0.988159V8.89452H1.97647V7.9062Z" fill="black"/>
      <path d="M12.8489 8.89482H11.8606V9.88313H12.8489V8.89482Z" fill="black"/>
      <path d="M12.8489 7.9062H11.8606V8.89452H12.8489V7.9062Z" fill="black"/>
      <path d="M1.97647 6.91827H0.988159V7.90659H1.97647V6.91827Z" fill="black"/>
      <path d="M12.8489 6.91827H11.8606V7.90659H12.8489V6.91827Z" fill="black"/>
      <path d="M4.94241 5.92993H3.9541V6.91824H4.94241V5.92993Z" fill="black"/>
      <path d="M9.8826 5.9299H8.89429V6.91821H9.8826V5.9299Z" fill="black"/>
      <path d="M4.94241 4.94165H3.9541V5.92996H4.94241V4.94165Z" fill="black"/>
      <path d="M8.89536 1.97684H7.90704V2.96515H8.89536V1.97684Z" fill="black"/>
      <path d="M8.89536 0.98822H7.90704V1.97653H8.89536V0.98822Z" fill="black"/>
      <path d="M5.93088 1.97684H4.94257V2.96515H5.93088V1.97684Z" fill="black"/>
      <path d="M5.93088 0.98822H4.94257V1.97653H5.93088V0.98822Z" fill="black"/>
      <path d="M6.91904 7.62939e-05L5.93073 7.62939e-05V0.988388H6.91904V7.62939e-05Z" fill="black"/>
      <path d="M7.90628 7.62939e-05L6.91797 7.62939e-05V0.988388H7.90628V7.62939e-05Z" fill="black"/>
      <path d="M9.8826 4.94174H8.89429V5.93005H9.8826V4.94174Z" fill="black"/>
      <path d="M1.97647 5.9299H0.988159V6.91821H1.97647V5.9299Z" fill="black"/>
      <path d="M12.8489 5.9299H11.8606V6.91821H12.8489V5.9299Z" fill="black"/>
      <path d="M13.837 4.94174H12.8487V5.93005H13.837V4.94174Z" fill="black"/>
      <path d="M12.8489 2.96498H11.8606V3.95329H12.8489V2.96498Z" fill="black"/>
      <path d="M11.8604 2.96509H10.8721V3.9534H11.8604V2.96509Z" fill="black"/>
      <path d="M0.988312 4.94174H0V5.93005H0.988312V4.94174Z" fill="black"/>
      <path d="M1.97647 2.96498H0.988159V3.95329H1.97647V2.96498Z" fill="black"/>
      <path d="M2.96487 2.96509H1.97656V3.9534H2.96487V2.96509Z" fill="black"/>
      <path d="M10.8721 3.95337H9.88379V4.94168H10.8721V3.95337Z" fill="black"/>
      <path d="M13.837 3.95337H12.8487V4.94168H13.837V3.95337Z" fill="black"/>
      <path d="M3.95413 3.95337H2.96582V4.94168H3.95413V3.95337Z" fill="black"/>
      <path d="M0.988312 3.95337H0V4.94168H0.988312V3.95337Z" fill="black"/>
      <path d="M11.8603 3.95331H10.8719V4.94162H11.8603V3.95331Z" fill="white"/>
      <path d="M6.91891 0.988159H5.9306V1.97647H6.91891V0.988159Z" fill="white"/>
      <path d="M1.97635 3.95331H0.988037V4.94162H1.97635V3.95331Z" fill="white"/>
  </svg>
);

export const StopwatchIcon = () => (
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="9.16669" y="5.78888" width="1.66667" height="1.66667" fill="currentColor"/>
    <path d="M9.16669 2.45555H10.8334V4.12222H9.16669V2.45555Z" fill="currentColor"/>
    <path d="M10.8333 2.45555H12.5V4.12222H10.8333V2.45555Z" fill="currentColor"/>
    <path d="M7.5 2.45555H9.16667V4.12222H7.5V2.45555Z" fill="currentColor"/>
    <rect x="10.8333" y="17.4556" width="1.66667" height="1.66667" transform="rotate(-180 10.8333 17.4556)" fill="currentColor"/>
    <rect x="7.5" y="5.78888" width="1.66667" height="1.66667" fill="currentColor"/>
    <rect x="12.5" y="17.4556" width="1.66667" height="1.66667" transform="rotate(-180 12.5 17.4556)" fill="currentColor"/>
    <rect x="5.83331" y="7.45555" width="1.66667" height="1.66667" fill="currentColor"/>
    <rect x="4.16669" y="9.12221" width="1.66667" height="1.66667" fill="currentColor"/>
    <rect x="14.1667" y="15.7889" width="1.66667" height="1.66667" transform="rotate(-180 14.1667 15.7889)" fill="currentColor"/>
    <rect x="15.8333" y="14.1222" width="1.66667" height="1.66667" transform="rotate(-180 15.8333 14.1222)" fill="currentColor"/>
    <rect x="4.16669" y="10.7889" width="1.66667" height="1.66667" fill="currentColor"/>
    <rect x="10.8333" y="5.78888" width="1.66667" height="1.66667" fill="currentColor"/>
    <rect x="7.5" y="15.7889" width="1.66667" height="1.66667" transform="rotate(-180 7.5 15.7889)" fill="currentColor"/>
    <rect x="10.8333" y="12.4556" width="1.66667" height="1.66667" transform="rotate(-180 10.8333 12.4556)" fill="currentColor"/>
    <rect x="12.5" y="10.7889" width="1.66667" height="1.66667" transform="rotate(-180 12.5 10.7889)" fill="currentColor"/>
    <rect x="14.1667" y="9.12221" width="1.66667" height="1.66667" transform="rotate(-180 14.1667 9.12221)" fill="currentColor"/>
    <rect x="9.16669" y="17.4556" width="1.66667" height="1.66667" transform="rotate(-180 9.16669 17.4556)" fill="currentColor"/>
    <rect x="14.1667" y="9.12221" width="1.66667" height="1.66667" fill="currentColor"/>
    <rect x="5.83331" y="14.1222" width="1.66667" height="1.66667" transform="rotate(-180 5.83331 14.1222)" fill="currentColor"/>
    <rect x="14.1667" y="10.7889" width="1.66667" height="1.66667" fill="currentColor"/>
  </svg>
);
